export default __webpack_public_path__ + "img/gibbs-dandy.png";